import SdkMethodsCollector from "@modules/sdk/methods/SdkMethodsCollector";
import Sdk from "@modules/sdk/Sdk";
import { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";

import { WishlistHooksDefinitions } from "./hooks/WishlistsSdkHooks";
import WishlistsSdkEvents from "./WishlistsSdkEvents";
import WishlistsSdkMethods from "./WishlistsSdkMethods";

class WishlistsSdk implements SdkRegisteredModuleInterface {
    public readonly events: WishlistsSdkEvents;

    public readonly methods: WishlistsSdkMethods;

    public readonly hooks = WishlistHooksDefinitions;

    constructor(private readonly _collector: SdkMethodsCollector) {
        this.events = new WishlistsSdkEvents();
        this.methods = new WishlistsSdkMethods(this._collector);
    }

    public register(sdk: Sdk & { wishlists?: WishlistsSdk }) {
        sdk.wishlists = this;
    }
}

export default WishlistsSdk;
